export const waMaxSizeText = 1024;
